import { Injectable } from '@angular/core';

import { IinvoiceSale } from './invoice.sale.type.js';
import { IinvoicePurchase } from './outcome.purchase.type';
import { Iclient } from './client.type';


import dataJSON1 from './registro-venta.json';
import dataJSON2 from './registro-compra.json';
import dataJSON3 from './clientes.json';
import dataJSON4 from './libro-ventas.json';

@Injectable()
export class DemoService {
	
	ventas: Array<IinvoiceSale> = dataJSON1;
	compras: Array<IinvoicePurchase> = dataJSON2;
	clientes: Array<Iclient> = dataJSON3;
	libroVentas: Array<any> = dataJSON4;

	constructor() {
		//console.log('asdasd');
	}

	getIncomeSales() {
		return this.ventas;
	}	
	
	getIncomeBuyers() {
		return this.compras;
	}

	getClients() {
		return this.clientes;
	}

	getBookSales() {
		return this.libroVentas;
	}
	
}
